import { render, staticRenderFns } from "./ProductModelUpload.vue?vue&type=template&id=1b951ee4&"
import script from "./ProductModelUpload.vue?vue&type=script&lang=ts&"
export * from "./ProductModelUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ProductModelUpload.vue?vue&type=style&index=0&id=1b951ee4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports